export const regexPattern = /^[a-zA-Z\s]*$/;
export const emailRegex =
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const specialChar=/[^a-zA-Z0-9]/


export const generateUuid = (inputString) => {
  // Remove spaces from the input string and append current timestamp
  let characters = inputString.replace(/\s+/g, '') + Date.now().toString();
  const charArray = characters.split('');

  // Shuffle the array of characters
  for (let i = charArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [charArray[i], charArray[j]] = [charArray[j], charArray[i]];
  }

  // Join the shuffled characters back into a string
  const shuffledString = charArray.join('');

  return shuffledString;
};


 export function getDuration(durationMs) {
    // Calculate the difference in milliseconds

    // Calculate days, hours, minutes, and seconds
    const days = Math.floor(durationMs / (24 * 60 * 60 * 1000));
    durationMs %= 24 * 60 * 60 * 1000;

    const hours = Math.floor(durationMs / (60 * 60 * 1000));
    durationMs %= 60 * 60 * 1000;

    const minutes = Math.floor(durationMs / (60 * 1000));
    durationMs %= 60 * 1000;

    const seconds = Math.floor(durationMs / 1000);

    return {
      days,
      hours,
      minutes,
      seconds,
    };
  }